<template>
  <LinkButton
    tag="button"
    type="button"
    secondary
    small-padding
    class="filter-tag"
    :aria-label="ariaLabel"
    @click="onClick"
  >
    <slot>{{ label }}</slot>

    <SvgIcon
      :image="deleteIcon"
      class="icon filter-tag__close-icon"
    />
  </LinkButton>
</template>

<script setup lang="ts">
import deleteIcon from '~/assets/images/delete-filter-tag.svg';
import { LinkButton } from '@i22team/td-longtail-vue-components';

export interface FilterTagProps {
  label: string;
  value?: SelectedTag['value'];
}

const props = withDefaults(defineProps<FilterTagProps>(), {
  value: undefined,
});

const emit = defineEmits<{
  click: [value: SelectedTag['value'] | undefined];
}>();

const filterKeyLabels: Record<FilterKeys, string> = {
  brandSlugs: 'Marke',
  colorSlugs: 'Farbe',
  compatibleProductFamilySlugs: 'Kompatibilitäts',
  productCategoryPaths: 'Kategorie',
  productProviders: 'Anbieter',
  productTagSlugs: 'Eigenschafts',
  anyInGroupOfProductTagSlugs: 'Kompatibilitäts',
  onetimePrice: 'Preis',
  discounted: 'Rabatt',
};

const ariaLabel = computed(() => {
  const filterTypeLabel = props.value?.key ? (filterKeyLabels[props.value.key] ?? '') : '';
  return `${filterTypeLabel}filter: ${props.label} entfernen`;
});

function onClick() {
  emit('click', props.value);
}
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.filter-tag {
  height: 24px;
  font-size: 0.8rem;
  line-height: 0.8rem;

  &__close-icon {
    margin-left: 10px;
  }
}
</style>
